<!--
  Implementation

  -in template:
   

  -import:
  import CardHeader from "@/components/Cards/parts/CardHeader.vue";
-->

<template>
  <div>
    <v-divider />
    <v-container class="d-flex"
                 :class="headerclass ? headerclass : 'pl-4 pr-2'"
                 fluid>
      <v-icon v-if="icon"
              class="mr-3"
              :color="invalidText ? 'error' : ''"
              :size="iconsize"
              v-text="icon" />
      <slot name="title">
        <component :is="fontsize ? fontsize : 'h4'"
                   :class="[headertextclass, invalidText ? 'error--text' : '']"
                   class="align-self-center useThemeTextColor">{{(title ? title : 'No header') + (noempty ? ' *':'')}}</component>
      </slot>
      <v-spacer />
      <!--
      <v-tooltip v-if="!editable && !selectable && !(editable === undefined && selectable === undefined)"
                 bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs"
                  v-on="on"
                  v-text="'mdi-lock-alert'" />
        </template>
        <span>{{lockedTooltip}}</span>
      </v-tooltip>
      -->
      <div class="d-flex shorter align-center">
        <slot name="addedbtns" />
        <v-scroll-x-transition>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-if="!editMode && selectable"
                     v-bind="attrs"
                     v-on="on"
                     @click="selectMode ? $emit('Normal') : $emit('Select')"
                     :class="selectMode ? '' : (editable ? 'mx-1' : '')"
                     icon>
                <v-icon :color="selectMode ? 'close' : ''"
                        v-text="selectMode ? 'mdi-close' : 'mdi-format-list-bulleted'">
                </v-icon>
              </v-btn>
            </template>
            <span>{{$t("servicesystem.text.swap")}}</span>
          </v-tooltip>
        </v-scroll-x-transition>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-if="editable && editable != 'hide' && !selectMode"
                   v-bind="attrs"
                   v-on="on"
                   icon
                   @click="editMode ? $emit('Normal') : $emit('Edit')">
              <v-icon :color="editMode ? 'close' : ''">{{editMode ? 'mdi-close' : 'mdi-pencil'}}</v-icon>
            </v-btn>
          </template>
          <span>{{editMode ? $t("servicesystem.text.cancel") : $t("servicesystem.text.edit")}}</span>
        </v-tooltip>
      </div>
    </v-container>
    <v-divider v-if="!nodivider" />
  </div>
</template>



<script>
export default {
  name: "CardHeader",
  props: [
    "title",
    "icon",
    "fontsize",
    "iconsize",
    "headerclass",
    "headertextclass",
    "nodivider",
    "noempty",
    "invalidText",
    "editMode",
    "selectMode",
    "selectable",
    "editable",
  ],

  data() {
    return {};
  },

  mounted() {},

  methods: {},

  computed: {
    lockedTooltip() {
      if (!this.editable && this.editable != undefined && !this.selectable && this.selectable != undefined) {
        return this.$t("servicesystem.common_objects.fallbackterms.edit_and_select_permissions_denied");
      } else if (!this.editable && this.editable != undefined && this.selectable === undefined) {
        return this.$t("servicesystem.common_objects.fallbackterms.edit_permissions_denied");
      } else if (this.editable === undefined && !this.selectable && this.selectable != undefined) {
        return this.$t("servicesystem.common_objects.fallbackterms.select_permissions_denied");
      } else {
        return "no options";
      }
    },
  },

  watch: {},
};
</script>
<style lang="scss" scoped>
.shorter {
  margin: -6px 0;
}
</style>